import {useEffect, useReducer} from "react";
import {useNavigate} from "react-router-dom";
import Input from "./Input";
import {useDispatch, useSelector} from "react-redux";
import {getCaptcha, postLoginData, selectCaptcha, selectLoginError} from "./loginSlice";

const initialState = {
    input: {name: '', password: '', code: ''},
    isChecked: false,
    error: {security: ''},
    captcha: {key: '', image: ''}
}

const reducer = (state, action) => {
    switch (action.type){
        case 'input':
            return {...state, input: {...state.input, [action.payload.name]: action.payload.value}}
        case 'checkbox':
            return {...state, isChecked: action.payload}
        case 'error':
            return {...state, error: {...state.error, security: action.payload}}
        case 'captcha':
            return {...state, captcha: {key: action.payload.key, image: action.payload.image}}
        default:
            throw new Error();
    }
}

const LoginForm = () => {
    const [state, dispatch] = useReducer(reducer, initialState, undefined)
    const storeDispatch = useDispatch()
    const navigate = useNavigate()

    const captchaObj = useSelector(selectCaptcha)
    const newError = useSelector(selectLoginError)
    useEffect(() => {
        if(captchaObj !== null){
            dispatch({type: 'captcha', payload: {key: captchaObj.key, image: captchaObj.image}})
        }
    }, [captchaObj])
    useEffect(() => {
        dispatch({type: 'error', payload: newError})
        dispatch({type: 'input', payload: {name: 'code', value: ''}})
    }, [newError])

    const handleChange = (e) => {
        let name = e.target.name;
        dispatch({type: 'input', payload: {name: [name], value: e.target.value}})
    }
    const handleChecked = () => {
        dispatch({type: 'checkbox', payload: !state.isChecked})
    }
    const handleSubmit = (e) => {
        e.preventDefault();

        const data = {
            username: state.input.name,
            password: state.input.password,
            captcha_key: state.captcha.key,
            captcha_value: state.input.code
        }
        const userPassword = state.input.password;
        storeDispatch(postLoginData({data, userPassword, navigate, storeDispatch}))
    }
    const handleNewCaptcha = () => {
        storeDispatch(getCaptcha())
    }

    useEffect(() => {
        storeDispatch(getCaptcha())
        // eslint-disable-next-line
    }, [])

    return(
        <form className='form' onSubmit={handleSubmit}>
            <Input type='text' name='name' value={state.input.name} placeholder='نام کاربری' label=':نام کاربری' handleChange={handleChange}  />
            <Input type='password' showPass={state.isChecked} name='password' value={state.input.password} placeholder='رمز عبور' label=':رمز عبور' handleChange={handleChange} />
            <div className='captcha-section'>
                <div>
                    <i className="fa fa-refresh reload-icon" aria-hidden="true" onClick={handleNewCaptcha}></i>
                    <img className="captcha-image" width="100px" height="45px" src={`data:image/png;base64,${state.captcha.image}`} alt='CaptchaCode' />
                </div>
                <Input type='text' name='code' value={state.input.code} placeholder='کد امنیتی' handleChange={handleChange} />
            </div>
            <Input type='checkbox' checked={state.isChecked} handleChange={handleChecked} label='مشاهده رمز عبور' />
            <button className='button'>ورود</button>
            {state.error.security && <p className='security-error'>{state.error.security}</p>}
        </form>
    )
}

export default LoginForm